import * as angular from 'angular'

import { CustomerSuggestions } from './customer-suggestions.service'

import { ReactCustomerBadgeComponent } from './react-customer-badge/ReactCustomerBadge'

angular
  .module('webregister.components')
  .service('customerSuggestions', CustomerSuggestions)
  .component('reactCustomerBadge', ReactCustomerBadgeComponent)
